module.exports = __webpack_public_path__ + "img/logo.adbc187a.png";